import { render, staticRenderFns } from "./SystemPageWrap.vue?vue&type=template&id=7efc6ba8&scoped=true&"
import script from "./SystemPageWrap.vue?vue&type=script&lang=js&"
export * from "./SystemPageWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efc6ba8",
  null
  
)

export default component.exports